import { useAuth } from "@/context/AuthContext";

export default function Profile() {
  const { user } = useAuth();
  return (
    <div>
      <h1 className="text-2xl font-extrabold text-midnight mb-6">My Profile</h1>
      <div className="rounded-3xl border border-border p-6 space-y-4 max-w-lg" data-testid="profile-card">
        {[["Name", user.name], ["Email", user.email], ["Phone", user.phone || "Not added"], ["Account type", user.role]].map(([k, v]) => (
          <div key={k} className="flex justify-between border-b border-border pb-3"><span className="text-sm text-muted-foreground">{k}</span><span className="text-sm font-semibold text-midnight">{v}</span></div>
        ))}
      </div>
    </div>
  );
}
